import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import {
  ButtonStatus,
  Column,
  Container,
  ModalBottomSheet,
  Picture,
  Row,
  Text
} from '@smuchile/pkg-unimarc-components'
import {
  Entry,
  eventClick,
  IEntriesProps,
  useContentful,
  useMobile,
  useOrder
} from '@smuchile/pkg-unimarc-hooks'
import { putCancelPurchase } from '@smuchile/pkg-unimarc-hooks/services/putCancelPurchase'
import { ResponseOrder } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IOrder'
import { statusCancelPurshase } from 'components'
import { handleStatusTextOrderDetail } from 'shared/helpers'
import { IDS_CONTENT_FUL_BY_STORE } from 'shared/constants'
import { getTitleStore } from 'shared/helpers/getTitleStore'

interface ModalConfirmateProps {
  imageModalConfirmCancelPurchase: string
  openModalConfirmate: boolean
  selectOption: Entry
  selectOptionOther: string
  setOpenModalConfirmate: React.Dispatch<React.SetStateAction<boolean>>
  setOpenModalError: React.Dispatch<React.SetStateAction<boolean>>
  setOpenPage: React.Dispatch<React.SetStateAction<boolean>>
}
export const ModalConfirmate = ({
  imageModalConfirmCancelPurchase,
  openModalConfirmate,
  selectOption,
  selectOptionOther,
  setOpenModalConfirmate,
  setOpenModalError,
  setOpenPage
}: ModalConfirmateProps): React.ReactElement => {
  const router = useRouter()
  const { isMobile } = useMobile()
  const { data: dataOrder } = useOrder({ oldOrders: true })
  const { text } = handleStatusTextOrderDetail(dataOrder?.data)
  const [loadingButton, setLoadingButton] = useState<ButtonStatus>('initial')
  const [dataContent, setDataContent] = useState<IEntriesProps>({})
  const courierNameNumber =
    dataOrder?.data?.shippingData?.logisticsInfo[0]?.deliveryIds[0]?.courierName.substring(
      0,
      4
    )
  const { data: CFData, isLoading: isCFLoading } = useContentful({
    id_contentful: `viewBlock`,
    options: {
      'sys.contentType.sys.id[in]': 'viewBlock',
      'sys.id[in]': IDS_CONTENT_FUL_BY_STORE[0]
    },
    reactQuery: {
      enabled: Boolean(courierNameNumber),
      retry: 3,
      staleTime: 1000 * 60 * 5, // for five minutes the information is not outdated
      refetchOnWindowFocus: false
    }
  })

  const handleButtonClicked = (option: string) => {
    eventClick({
      event: 'interacciones_mis_compras',
      eventAction: 'clic',
      eventCategory: 'cancelar-compra-confirmar',
      event_label:
        (option == 'cancelar' && 'cancelar compra') ||
        (option == 'volver' && 'volver a mi compra'),
      id_compra: dataOrder?.data?.sequence,
      estado_compra: text
    })
  }

  const handleCancelPurshase = async (dataOrder: ResponseOrder) => {
    setLoadingButton('loading')
    const { text } = handleStatusTextOrderDetail(dataOrder.data)
    const enabledCancelPurshase = statusCancelPurshase.includes(text)
      ? false
      : true

    const option = {
      action: 'problema_con_productos_clone',
      otherReason: selectOptionOther,
      reason: selectOption?.fields?.value ?? '',
      store: getTitleStore(dataContent, courierNameNumber)
    }
    const bodyPutCancelPurshase = {
      application: 'web',
      courier:
        dataOrder.data.shippingData.logisticsInfo[0].deliveryIds[0].courierName,
      name:
        dataOrder.data.clientProfileData.firstName +
        ' ' +
        dataOrder.data.clientProfileData.lastName,
      options: { ...option },
      order_id: dataOrder.data.ticketNumber,
      phone: dataOrder.data.clientProfileData.phone,
      sequence: dataOrder.data.sequence
    }

    const responsePut = await putCancelPurchase(bodyPutCancelPurshase)
    if (enabledCancelPurshase || responsePut.status === 410) {
      setOpenModalConfirmate(false)
      setOpenModalError(true)
    }

    if (responsePut.status === 201) {
      setOpenPage(true)
    }
  }

  const handleCancel = () => {
    handleButtonClicked('cancelar')
    handleCancelPurshase(dataOrder)
  }

  const handleBack = () => {
    handleButtonClicked('volver')
    setOpenModalConfirmate(false)
    router.back()
  }

  useEffect(() => {
    if (!isCFLoading && CFData) {
      setDataContent(CFData)
    }
  }, [isCFLoading, CFData])

  return (
    <ModalBottomSheet
      isMobile={isMobile}
      isOpen={openModalConfirmate}
      onClose={() => {
        return setOpenModalConfirmate(false)
      }}
      primaryBtnLabel='Cancelar compra'
      primaryCTA={handleCancel}
      secondaryBtnLabel='Volver atrás'
      secondaryCTA={handleBack}
      statusBtn={loadingButton}
    >
      <>
        <Column
          alignItems='center'
          margin='36px 0 0 0'
          width='250px'
        >
          <Picture
            alt='galleta'
            height='auto'
            src={imageModalConfirmCancelPurchase}
            width='198px'
          />
          <Container
            justifyContent='center'
            margin='16px 0'
          >
            <Text
              fontSize='xl'
              fontWeight='medium'
              textAlign='center'
            >
              Piénsalo bien...
            </Text>
          </Container>
        </Column>
        <Row maxWidth='277px'>
          <Text
            fontWeight='regular'
            isFlex
            textAlign='center'
          >
            Si cancelas tu compra no recibirás tus productos.
          </Text>
        </Row>
      </>
    </ModalBottomSheet>
  )
}
